/** @jsx React.DOM */

var _ = require("lodash");
var Immutable = require("immutable");
var React = require("react/addons");

var TreeActions = require("editor/actions/TreeActions");

var Leaf = React.createClass({displayName: 'Leaf',
  handleOpenFile: function(tree, e) {
    TreeActions.openFile(tree);
  },

  handleContextMenu: function(e) {
    this.props.handleContextMenu(e, this.props.leaf);
  },


  render: function() {
    var leaf = this.props.leaf;
    if (!leaf) return null;

    return (
      React.DOM.li({className: "tree-item", 'data-template': "treeitem", role: "treeitem"}, 
        React.DOM.button({className: "tree-item-name", 
          onContextMenu: this.handleContextMenu, 
          onDoubleClick: this.handleOpenFile.bind(this, leaf)}, 

          React.DOM.span({className: "glyphicon icon-file glyphicon-file"}), 
          React.DOM.span({className: "tree-label"}, leaf.name)
        )
      )
    );
  }
});

module.exports = Leaf;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/tree/Leaf.js
 ** module id = 72
 ** module chunks = 0
 **/